import { ScrollArea } from "//ringconn.com/cdn/shop/t/222/assets/theme.js?v=28201614200241634521783926809";
import { timeline, stagger } from "//ringconn.com/cdn/shop/t/222/assets/vendor.min.js?v=110209841862038618801782390016";

/**
 * 图片文本并排组件
 * 实现水平滚动和前后控制功能
 */
class ImageBelowText extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.children);

    // 初始化滚动区域
    this.scrollArea = new ScrollArea(this);

    // 添加控制事件监听
    this.addEventListener("control:prev", this._prev.bind(this));
    this.addEventListener("control:next", this._next.bind(this));

    // 添加动画效果
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      this._setupAnimation();
    }
  }

  /**
   * 设置入场动画
   */
  _setupAnimation() {
    const items = this.querySelectorAll(".image-text-item");
    if (items.length > 0) {
      timeline([
        [
          items,
          { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] },
          { duration: 0.4, delay: stagger(0.1) },
        ],
      ]);
    }
  }

  /**
   * 向前滚动
   */
  _prev() {
    if (!this.items.length) return;
    this.scrollBy({
      left: (document.dir === "rtl" ? 1 : -1) * this.items[0].clientWidth,
      behavior: "smooth",
    });
  }

  /**
   * 向后滚动
   */
  _next() {
    if (!this.items.length) return;
    this.scrollBy({
      left: (document.dir === "rtl" ? -1 : 1) * this.items[0].clientWidth,
      behavior: "smooth",
    });
  }
}

/**
 * 图片在文本下方的组件
 * 继承自ImageTextParallel，保持相同的滚动行为
 */
class ImageTextParallel extends ImageBelowText {
  connectedCallback() {
    super.connectedCallback();

    // 添加响应式处理
    this._setupResponsive();
    this.init();
  }
  init() {
    const parallelId = this.id;
    const id = parallelId.split("image-text-parallel-")[1];
    const pressId = `swiper-parallel-carouse-${id}`;
    // console.log(id, parallelId, pressId, 'id');
    const paralleNextButton = document.querySelector(`button[is="next-button"][aria-controls="${parallelId}"]`);
    const pressNextButton = document.querySelector(`button[is="next-button"][aria-controls="${pressId}"]`);
    const parallePrevButton = document.querySelector(`button[is="prev-button"][aria-controls="${parallelId}"]`);
    const pressPrevButton = document.querySelector(`button[is="prev-button"][aria-controls="${pressId}"]`);
    if (paralleNextButton && pressNextButton) {
      paralleNextButton.addEventListener("click", () => {
        pressNextButton.click();
      });
    }
    if (parallePrevButton && pressPrevButton) {
      parallePrevButton.addEventListener("click", () => {
        pressPrevButton.click();
      });
    }
    // const nextButton = this.querySelector('.next-button');
  }
  /**
   * 设置响应式行为
   */
  _setupResponsive() {
    // 获取父级section以便访问设置
    const parentSection = this.closest(".shopify-section");
    if (!parentSection) return;

    // 监听窗口大小变化
    window.addEventListener("resize", this._handleResize.bind(this));
    this._handleResize();
  }

  /**
   * 处理窗口大小变化
   */
  _handleResize() {
    const isMobile = window.innerWidth < 700;
    this.classList.toggle("is-mobile", isMobile);
  }
}

// 注册自定义元素
if (!window.customElements.get("image-text-parallel")) {
  window.customElements.define("image-text-parallel", ImageTextParallel);
}

if (!window.customElements.get("image-below-text")) {
  window.customElements.define("image-below-text", ImageBelowText);
}

export { ImageTextParallel, ImageBelowText };
